import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import stylesCadastro from "../Cadastro.module.css";
import { Alert, Snackbar } from "@mui/material"
import UploadInput from "../../../../components/Inputs/UploadInput"
import servSolicitacaoVistoria from "../../../../services/login/servSolicitacaoVistoria";

import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";

const Documentos = ({ 
        podeFazerUpload, 
        codigoSolicitacao, 
        documentos, 
        setOpenError, 
        setErrorMessage, 
        parecerDocumentos, 
        setIsLoading, 
        tipoRamal, 
        classificacaoGeracao,
        setTypeAlert}) => {
    const { register } = useForm();
    const [severity, setSeverity] = useState("info");
    const [openUpload, setOpenUpload] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    let podeAlterarSolic = (podeFazerUpload === 0 || podeFazerUpload === 2) ? true : false; 

    useEffect(() => {
        const handleDocumentos = () => {
            if(!documentos) return;
            
            documentos.map((doc) => {
                // 2 - Obrigatoriedade conforme critÃ©rio
                if(doc.Obrigatorio === 2) {
                    doc.CriterioAereo = (doc.ObrigAereo && tipoRamal === 1);
                    doc.CriterioSubterraneo = (doc.ObrigSubterraneo && tipoRamal === 2);
                    doc.CriterioMicrogeracao = (doc.ObrigMicrogeracao && classificacaoGeracao === 1);
                    doc.CriterioMinigeracao = (doc.ObrigMinigeracao && classificacaoGeracao === 2);
                }

                // Valida se limita extensões
                if(!doc.DefinirExtensoesValidas || doc.ExtensoesValidas.trim() === '') {
                    doc.ExtensoesValidas = '*';
                } 
            })
    
            setDocumentosObrigatorios(documentos);
        }

        handleDocumentos();
    }, [tipoRamal, classificacaoGeracao, documentos]);

    const handleCloseInfo = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenUpload(false);
        }

        setOpenUpload(false);
    }

    const handleUploadArquivos = async (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;

        if (file === null) {
            setOpenError(true);
            return setErrorMessage("Selecione um arquivo");
        }

        try {
            const formData = new FormData();

            let nomeArquivoSeparadoPorPonto = file.name.split('.');
            const extensaoArquivo = nomeArquivoSeparadoPorPonto.pop();
            const nomeArquivo = nomeArquivoSeparadoPorPonto.join('.');
            const size = file.size / 1024; // Convertendo de byte para KB

            formData.append("Arquivo", file);
            formData.append("CodigoSolicitacaoVistoria", codigoSolicitacao);

            const id = e.target.id;
            let codigos = id.split("-");

            if (codigos[5] != 0) {
                formData.append("CodigoDocumento", codigos[5]);    
            }

            if(codigos[7] !== '*' && !codigos[7].includes(extensaoArquivo)) {
                setOpenError(true);
                setIsLoading(false);
                setTypeAlert("error");
                setErrorMessage(`Não é possível adicionar arquivos com a extensão "${extensaoArquivo}".`);
                return;
            }

            formData.append("CodigoConfiguracaoDoc", codigos[3]);
            formData.append("CodigoClassificacaoDoc", codigos[1]);
            formData.append("NomeArquivo", nomeArquivo);

            formData.append("ExtensaoArquivo", extensaoArquivo);
            formData.append("TamanhoKbArquivo", Math.trunc(size));
            
            setOpenUpload(true);
            setSeverity("info");
            setUploadMessage("Upload de arquivo iniciado");
            

            setTimeout(() => {
                setOpenUpload(false);
            }, [3000]);

            setIsLoading(true);
            let response = await servSolicitacaoVistoria.InserirDocumentoNaSolicitacao(formData);
        
            documentosObrigatorios.map((documento) => {
                if (documento.Id == codigos[3]) {
                    documento.CodigoDocumento = parseInt(response.Content);
                    documento.NomeArquivo = file.name;
                }
                return documento;
            })

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
            setTimeout(() => {
                setOpenUpload(false);
            }, [1000]);

        } catch (err) {
            setTypeAlert("error");
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setErrorMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleDownloadArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            let response = await servSolicitacaoVistoria.RealizarDownloadDocumento(codigoDocumento);
            downloadConteudoBase64(response.Content.Nome, response.Content.Arquivo);
            
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const handleInputDocumentos = () => {
        return documentosObrigatorios && documentosObrigatorios.map((doc) => {
            if (doc.Obrigatorio !== 2) {
                return ContainerUpload(doc);
            } else if (doc.DocumentoCriterioSelecionado && doc.Obrigatorio === 2 && (doc.CriterioAereo || doc.CriterioSubterraneo || doc.CriterioMinigeracao || doc.CriterioMicrogeracao)) {
                return ContainerUpload(doc);
            }else if(!doc.DocumentoCriterioSelecionado && doc.Obrigatorio === 2) {
                return ContainerUpload(doc);
            }
            return null;
        });
    }

    const handleRemoverArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            await servSolicitacaoVistoria.RemoverDocumento(codigoDocumento);
            
            setDocumentosObrigatorios((prev) =>
            prev.map((doc) => {
                if (doc.CodigoDocumento === codigoDocumento) {
                    return {
                        ...doc,
                        CodigoDocumento: null,
                        NomeArquivo: null
                    };
                }
                return doc;
            }));

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo excluído com sucesso");
            setIsLoading(false);
        }
        catch(err) {
            setOpenUpload(true);
            setSeverity("error");
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setUploadMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const ContainerUpload = (doc) => {
        return (
            <div className={stylesCadastro['upload-field']} key={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}`}>
                <UploadInput 
                    handleUploadArquivos={handleUploadArquivos} 
                    handleDownloadArquivo={handleDownloadArquivo}
                    handleRemoverArquivo={handleRemoverArquivo}
                    id={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}-extensoes-${doc.ExtensoesValidas}`} 
                    label={doc.Descricao} 
                    register={register} 
                    registerName={doc.Descricao.replace('/\s/g', '-')}
                    obrigatorio={doc.Obrigatorio} 
                    codigoDocumento={doc.CodigoDocumento || 0} 
                    disabled={!podeAlterarSolic} 
                    nomeArquivo={doc.NomeArquivo}
                    origemSolicitacao={true}
                    criterioAereo={doc.CriterioAereo}
                    criterioSubterraneo={doc.CriterioSubterraneo}
                    criterioMinigeracao={doc.CriterioMinigeracao}
                    criterioMicrogeracao={doc.CriterioMicrogeracao}
                    extensoesValidas={doc.ExtensoesValidas}
                />   
            </div> 
        )
    }

    return (
        <>
            <div className={stylesCadastro['cadastro-documentos']}>
                { handleInputDocumentos() }
            </div>
            <Snackbar open={openUpload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%'}} >
                    {uploadMessage}
                </Alert>
            </Snackbar>
        </>
    )
}

export { Documentos }